/**
 * readFormDeriveCellValue
 *
 * The single reader for a cell address that MAY carry a composite sub-field.
 * Split at the FIRST dot, exactly as `arFormulaTargetFieldSegments` splits a
 * write address: undotted reads the cell's own `value`, dotted reads the parent
 * cell's `value.fields.<sub>.value` — the very location a projection's dotted
 * column writes, so an address `isColumnPathTypeId` admits always resolves to a
 * real readable path. Returns the raw value; every caller keeps its own
 * post-processing. Consumers: `computeFormDerives` (`effectiveCellValue` and
 * `cellCanon`) and `isFormDeriveMaterialRowChange`'s value comparison. A second
 * spelling of this read is the bug it exists to prevent: the trigger would call
 * a sub-field edit immaterial while the engine computes a new value from it, and
 * no later pass repairs what nothing observed.
 */

import type { ArCell, TypeId } from '../System.Artifacts.types';

function readFormDeriveCellValue(
  cells: Partial<Record<TypeId, ArCell>> | undefined,
  typeId: TypeId,
): unknown {
  const dotIndex = typeId.indexOf('.');
  if (dotIndex === -1) return cells?.[typeId]?.value;

  const parent = cells?.[typeId.slice(0, dotIndex)]?.value as
    | { fields?: Record<string, { value?: unknown } | undefined> }
    | undefined;
  return parent?.fields?.[typeId.slice(dotIndex + 1)]?.value;
}

export { readFormDeriveCellValue };
